module.exports = __webpack_public_path__ + "static/media/uttt.052e1da4.png";